import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import createFormField from 'ExportDialog/modal/formFields/FormField';
import { ALL_CRM_COLUMNS, COLUMNS_IN_VIEW_ONLY, LIMITED_PRESET_COLUMNS } from 'email-management-lib/refactor/constants/manage/exportConstants';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function IncludeAllColumnsFormField({
  onChange
}) {
  const handleChecked = useCallback(checked => onChange(checked), [onChange]);
  return /*#__PURE__*/_jsx(FormControl, {
    "data-test-id": "export-columns-field",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.modals.export.chooseWhatYouLike"
    }),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "framework-export-column-selection",
      children: [/*#__PURE__*/_jsx(RadioInput, {
        defaultChecked: true,
        onChange: () => handleChecked(COLUMNS_IN_VIEW_ONLY),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.modals.export.exportOnlyPropertiesInTheView"
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        onChange: () => handleChecked(ALL_CRM_COLUMNS),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.modals.export.exportAllPropertiesOnRecords"
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        onChange: () => handleChecked(LIMITED_PRESET_COLUMNS),
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsxs("div", {
          className: "display-flex flex-column",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.modals.export.exportLimitedPreset.title"
          }), /*#__PURE__*/_jsx("small", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.modals.export.exportLimitedPreset.subtitle"
            })
          })]
        })
      })]
    })
  });
}
export default createFormField(IncludeAllColumnsFormField, ALL_CRM_COLUMNS);